import { type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { styled, Box, keyframes, Stack } from "~/common/mui";
import { Typography } from "~/common/mui/Typography/Typography";
import { C_PRIMARY } from "~/common/components/icon/Colors";

const spinnerAnimation = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`;

interface Props {
  className?: string;
  label?: ReactNode;
}

const BarContainer = styled(Box)({
  width: "100%",
  overflow: "hidden",
});

const BarInner = styled(Box)({
  width: "100%",
  height: "2px",
  backgroundColor: C_PRIMARY,
  animation: `${spinnerAnimation} 3s infinite`,
});

const Spinner = ({ className, label }: Props) => {
  const { t } = useTranslation();

  return (
    <Stack className={className} gap={1} alignItems="center">
      <BarContainer>
        <BarInner />
      </BarContainer>
      <Typography color="primary" variant="labelLarge">
        {label || t("spinner.text")}
      </Typography>
    </Stack>
  );
};

export default Spinner;
